import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { FilterTable } from '../models/filter.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from '../../base/components/base-form.component';
import { MaskService } from '../services/mask.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent<T> extends BaseFormComponent<T> implements OnInit {

  queryParams: Record<string,null> = {};
  @Input() canClose: boolean = true;
  @Input() canClear: boolean = true;
  @Input() canFilter: boolean = true;
  @Input() filterData: FilterTable[] = [];
  @Output() search = new EventEmitter<Record<string, any>[]>();
  @Output() close = new EventEmitter<void>();
  @Output() formDataChange= new EventEmitter<FormGroup>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private acRoute: ActivatedRoute,
    private maskService:MaskService
  ) {
    super(acRoute);
  }

  ngOnInit() {
    this.acRoute.queryParams.subscribe(params => {
      if (params) {
        this.queryParams = params;
        try {
          this.filterData = this.filterData.map(f => {
            if (f.key && f.key_start && f.key_end && params[f.key_start] && params[f.key_end]) {
              var date_start = (new Date(params[f.key_start])).toISOString() || null;
              var date_end = (new Date(params[f.key_end])).toISOString() || null;
              return { ...f, value: value, start: date_start, end: date_end};
            }

            if (f.key && params[f.key] !== undefined) {
              // var value = (['select', 'number']).includes(f.type)? +params[f.key] : params[f.key];
              var value = (['number']).includes(f.type)? +params[f.key] : params[f.key];
              return { ...f, value: value};
            }
            return f;
          });
          this.updateFormData();
          this.onSearch()
        } catch (e) {
          console.error('Erro ao aplicar filtro dos query params', e);
        }
      }
    });
    this.initForm();
    if (this.formDataChange.observers.length > 0) {
      this.form.valueChanges.subscribe(value => {
        this.formDataChange.emit(this.form);
      });
    }
  }

  ngOnChanges(changes : SimpleChanges) {
    if (changes['filterData'] ) {
      this.filterData = changes['filterData'].currentValue;
      if (!this.form) {
        this.initForm();
      }
      else{
        this.updateFormData();
        setTimeout(() => this.changeDetectorRef.detectChanges(), 0);
      }
    }
  }

  updateFormData(){
    const newValues: { [key: string]: any } = {};
    this.filterData?.forEach((f:FilterTable) => {
      if (f.type === 'rangeDate' && f.key_start && f.key_end) {
        newValues[f.key_start] = f.start ?? '';
        newValues[f.key_end] = f.end ?? '';
      } else if (f.key) {
        var value = null;
        if(this.queryParams[f.key]){
          value = this.queryParams[f.key]
          if(f.type === 'select'){
            value =  +(value) || value;
          }
        }
        newValues[f.key] = value ?? f.value ?? null;
      }
    });
    this.form.patchValue(newValues);
  }

  initForm(recoverQuery:boolean = true): void {
    const controls = this.filterData.reduce((a:{ [key: string]: FormControl }, f) => {
      const validators = [];
      if (f.required) validators.push(Validators.required);
      if (f.maxLength) validators.push(Validators.maxLength(f.maxLength));
      if (f.minLength) validators.push(Validators.minLength(f.minLength));
      if(f.type == 'rangeDate' && f.key_start && f.key_end){
        a[f.key_start] = new FormControl(f.start, validators);
        a[f.key_end] = new FormControl(f.end, validators);
      }
      else if(f.key){
        a[f.key] = new FormControl(f.value, validators);
      }
      return a;
    }, {} as { [key: string]: FormControl });
    this.form = new FormGroup(controls);
    this.changeDetectorRef.detectChanges();
    if(recoverQuery){
      this.updateFormData();
    }
  }

  clearFilter():void{
    this.filterData = this.filterData.map(f => {
      return { ...f, value: null };
    });
    this.saveFilterToQueryParams(this.filterData);
    this.initForm(false);
    this.onSearch();
  }

  getfilter(item:any): FormGroup {
    return item as FormGroup;
  }

  onClose(): void{
    this.close.emit();
  }

  onSearch(): void{
    if (this.form.valid){
      var formValue = this.form.value;
      var filterData = this.filterData.map((f) => {
        if(f.type == 'rangeDate' && f.key_start && f.key_end){
          return {...f, start:formValue[f.key_start], end:formValue[f.key_end], value:formValue[f.key_start], key_start: f.key_start, key_end: f.key_end };
        } else if(f.key){
          return {...f, value:formValue[f.key] };
        }
        return f
      });
      this.saveFilterToQueryParams(filterData);
      this.search.emit(filterData);
    }
    else{
      this.markAsDirty();
    }
  }

  saveFilterToQueryParams(filterData: any) {
    const filtersObj = filterData
      .reduce((acc: any, curr: any) => {
        if(curr.key_start && curr.key_end){
          acc[curr.key_start] = curr.start !== null && curr.start !== undefined && curr.start !== '' ? new Date(curr.start) : null;
          acc[curr.key_end] = curr.end !== null && curr.end !== undefined && curr.end !== '' ? new Date(curr.end) : null;
          acc[curr.key] = value;
          return acc;
        }else{
          var value = curr.value !== null && curr.value !== undefined && curr.value !== '' ? curr.value : null;
          acc[curr.key] = value;
          return acc;
        }
    }, {});
    this.router.navigate([], {
      relativeTo: this.acRoute,
      queryParams: filtersObj,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
  
  maskCpf(key:string,event:Event):void{
    var value = (event.target as HTMLInputElement).value;
    var newValue = this.maskService.maskCpf(value);
    this.form.get(key)?.setValue(newValue ?? null);
  }
}
